import React from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";

function Creators() {
  return (
    <footer className="tc-creators">
      <div className="container">
        <div className="text-center pt-60 pb-200">
          <LazyLoadImage
            src="/home_borin/assets/images/logo.svg"
            alt="Logo da Wiser"
            effect="blur"
            width={"auto"}
            height={"100%"}
          />

          <h2 className="js-splittext-lines color-gray mt-40">
            <span className="title text-center fsz-65 color-brown1 text-uppercase font-palast-regular ltspc-10">
              Idealizadores
            </span>
          </h2>

          <div className="text-content pb-100 mt-50">
            <p className="fsz-16 pt-10 text-center color-gray wow zoomIn slow ">
              A parceria entre Luiz Carlos Dale Nogari dos Santos e Pedro Brair
              nasceu de uma amizade de longa data e de uma admiração mútua por
              inovação e excelência. Compartilhando gostos parecidos e sendo
              consumidores exigentes de produtos de alto padrão, ambos sempre
              tiveram um interesse genuíno pelo mercado imobiliário.
            </p>
            <p className="fsz-16 pt-10 text-center color-gray wow zoomIn slow ">
              A principal motivação para essa união foi criar algo
              verdadeiramente único, capaz de agregar valor ao mercado e
              redefinir os padrões de exclusividade em Passo Fundo. A
              localização privilegiada do Wiser e o desejo de oferecer um
              produto diferenciado foram fatores decisivos que os uniram em
              torno desse propósito comum. Conhecendo a expertise da Borin, uma
              empresa com excelência em construção e gestão de empreendimentos,
              Luiz Carlos e Pedro Brair formataram um modelo de parceria ideal.
            </p>
            <p className="fsz-16 pt-10 text-center color-gray wow zoomIn slow ">
              A Borin não apenas possui a habilidade técnica necessária para
              materializar um projeto dessa magnitude, mas também compartilha
              dos mesmos valores, através dos seus sócios Márcio e Rachel Borin,
              que norteiam o Wiser: inovação, qualidade e comprometimento.
            </p>
            <p className="fsz-16 pt-10 text-center color-gray wow zoomIn slow ">
              A credibilidade do trio – Luiz Carlos, Pedro Brair e Borin
              Construções – é incontestável, sustentada por históricos marcados
              por empreendedorismo e sucesso. Juntos tornaram possível um
              projeto que combina sabedoria, modernidade e visão de futuro,
              transformando o Wiser em um marco que transcende gerações.
            </p>
          </div>

          <div className="flex-grow col-lg-12 d-flex text-center card-content">
            <div className="col-lg-6 creators-card wow zoomIn slow">
              <LazyLoadImage
                src="/home_borin/assets/images/luiz.webp"
                alt="Foto do Luiz Carlos"
                effect="blur"
                width={"231px"}
                height={"317px"}
              />
              <h3 className="js-splittext-lines fsz-36 mt-30 ltspc-5 color-gray1 lh-2 font-palast-regular">
                Luiz Carlos <br /> Dale Nogari dos Santos
              </h3>
              <p className="fsz-16 pt-40 color-gray ms-30 me-30 wow zoomIn slow">
                Luiz Carlos Dale Nogari dos Santos é um visionário empreendedor,
                conhecido por sua ousadia e inovação. Com uma trajetória marcada
                por conquistas em diversos setores, ele transformou
                oportunidades em histórias de sucesso. Sua liderança inspiradora
                e sua busca constante pela excelência fazem dele a força por
                trás do Wiser.
              </p>
            </div>
            <div className="col-lg-6 creators-card">
              <LazyLoadImage
                src="/home_borin/assets/images/pedro.webp"
                alt="Foto do Pedro Henrique"
                effect="blur"
                width={"231px"}
                height={"317px"}
              />
              <h3 className="fsz-36 mt-30 ltspc-5 color-gray1 lh-2 font-palast-regular">
                Pedro Henrique <br /> Kappaun Brair
              </h3>
              <p className="fsz-16 pt-40 color-gray ms-30 me-30">
                Pedro Brair é o fundador da Rede de Farmácias São João, uma das
                maiores do Brasil. Começou sua jornada empreendedora aos 20 anos
                e transformou a rede em referência de qualidade e atendimento.
                Com visão estratégica e compromisso com a comunidade, ele
                inspira novos projetos, como o Wiser, símbolo de excelência e
                modernidade.
              </p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Creators;
